/* 📦 LIBS */
import {
    AreaChart, Area, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from "recharts";

/* 🧩 COMPONENTS */
import { CustomLoading } from "../../../../Components";

/* 🎨 STYLES */
import {
    Container, ContainerDay, DayButton, DayStatus, Greenfill, Yellowfill, Redfill, Purplefill, ContainerGraph, ContainerDays,
} from "./styles";

/* 🔧 UTILS */
import { GetCardsColor } from "../../../../util/Colors";
import { getDataString, getLastDay } from "../../../../util/Months";

const customTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{ background: "white", border: "1px solid #ccc", padding: "10px" }}>
                {payload.map((p, idx) => (
                    <div key={idx} style={{ color: p.stroke }}>
                        <strong>{p.name}: </strong>{p.value}
                    </div>
                ))}
            </div>
        );
    }
    return null;
};

const Bardays = ({ChangeDays, type, month, year, day, disabled, Mode, days, isLoading, CardStatus, colorArea}) => {
    const Data = new Date();
    const CurrentDay = Data.getDate();
    const activeDay = Data.getFullYear() === year && getDataString(Data.getMonth() + 1) === month;
    const elementsArray = Array.from({
        length: Mode === 1 ? 24 : Mode === 2 ? 7 : getLastDay(month),
    });

    // Recharts expects flat array of objects like:
    // [ { date: '07-01', serie1: 12, serie2: 24 }, ... ]
    const parseChartData = (series) => {
        const result = [];
        if (!Array.isArray(series) || series.length === 0) return result;

        const length = series[0].data.length;
        for (let i = 0; i < length; i++) {
            const point = {};
            point.date = series[0].data[i].xFormatted; // e.g. "07-01"
            series.forEach((serie) => {
                point[serie.id] = serie.data[i].y;
            });
            result.push(point);
        }
        return result;
    };

    console.log("days", days)

    const chartData = parseChartData(days);

    return (
        <Container>
        {type === "graph" ? 
            (
            isLoading ? 
                (<CustomLoading width={"150px"} height={"150px"} />):
                (
                <ContainerGraph>
                    <ContainerDays>
                    {elementsArray.map((_, index) => (
                        <DayButton
                        $background={GetCardsColor(CardStatus).background}
                        key={index}
                        disabled={
                            (CurrentDay < index + 1 && activeDay) ||
                            isLoading ||
                            disabled ||
                            Mode !== 0
                        }
                        $active={parseInt(day) === index + 1 && Mode === 0}
                        onClick={() => ChangeDays(getDataString(index + 1))}
                        >
                        {getDataString(index + 1)}
                        </DayButton>
                    ))}
                    </ContainerDays>

                    <ResponsiveContainer width="100%" height={220}>
                    <AreaChart data={chartData} margin={{ top: 5, right: 20, bottom: 60, left: -20 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <YAxis tick={{ fontSize: 14 }} />
                        <Tooltip content={customTooltip} />
                        {days.map((serie, index) => (
                        <Area
                            key={index}
                            type="linear"
                            dataKey={serie.id}
                            stroke={colorArea? GetCardsColor(CardStatus).background : ["#4361EE"]}
                            fill={colorArea? GetCardsColor(CardStatus).background : ["#4361EE"]}
                            strokeWidth={2}
                            dot={{ r: 2 }}
                            activeDot={{ r: 3 }}
                            fillOpacity={0.35}
                            isAnimationActive={false}
                        />
                        ))}
                    </AreaChart>
                    </ResponsiveContainer>
                </ContainerGraph>
                )
            ) : (
                days.map((item, index) => (
                <ContainerDay key={index}>
                    <DayButton
                    $active={parseInt(day) === index + 1}
                    disabled={(CurrentDay < index + 1 && activeDay) || isLoading || disabled}
                    onClick={() => ChangeDays(getDataString(index + 1))}
                    >
                    {getDataString(index + 1)}
                    </DayButton>
                    <DayStatus>
                    {isLoading ? (
                        <CustomLoading width={"150px"} height={"150px"} />
                    ) : (
                        <>
                        <Greenfill $altura={item?.green} />
                        <Yellowfill $altura={item?.yellow} />
                        <Redfill $altura={item?.red} />
                        <Purplefill $altura={item?.purple} />
                        </>
                    )}
                    </DayStatus>
                </ContainerDay>
                ))
            )}
        </Container>
    );
};

export default Bardays;
